export const getCurrentWeekRange = (add) => {
  const today = new Date();
  const day = today.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const monday = new Date(today);
  monday.setDate(today.getDate() + diffToMonday + add * 7);
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { monday, sunday };
};

export const toDateKey = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDayLabel = (date) => {
  const daysShort = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
  const dayName = daysShort[date.getDay()];
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);
  return `${dayName} ${day}.${month}.${year}`;
};

const normalizeDate = (d) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const getDayStatus = (date, publicHolidays, schoolHolidays) => {
  // Convert the date to "YYYY-MM-DD" string in local time
  const dateKey = toDateKey(date); // stays as you had

  // PUBLIC HOLIDAYS
  const isPublicHoliday = publicHolidays.includes(dateKey);

  // SCHOOL HOLIDAYS
  const isSchoolVacation = schoolHolidays.some((v) => {
    // convert start/end to "YYYY-MM-DD" strings
    const startKey = v.start.toLocaleDateString('sv-SE'); // "YYYY-MM-DD"
    const endKey = v.end.toLocaleDateString('sv-SE');
    return dateKey >= startKey && dateKey <= endKey;
  });

  const isWeekend = date.getDay() === 0 || date.getDay() === 6;

  return { isPublicHoliday, isSchoolVacation, isWeekend };
};

export const toLocalInputValue = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const pad = (n) => n.toString().padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};